import { atom } from "jotai";
export const mailAtom = atom<string>("");
